import { css } from '@emotion/react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React from 'react';
import RatingImage from '../../../public/static/images/rating-star.svg';
import { breakpoints } from '../../utils/styleguide';

const Stars = styled.div`
  padding: 2px;
`;

interface RatingProps {
  rating?: number;
  className?: string;
}
const Rating = ({ rating, className }: RatingProps) => {
  if (!rating) {
    return null;
  }
  const stars = [];
  for (let i = 0; i < 5; i++) {
    stars.push(
      <RatingImage
        loading="lazy"
        key={i}
        css={css`
          height: 16px;
          width: 16px;
          ${breakpoints.desktop} {
            height: 24px;
            width: 24px;
          }
          ${i >= rating && 'filter: grayscale(100%);'}
        `}
        alt={`star in rating ${rating}/5`}
      />,
    );
  }

  return <Stars className={className}>{stars}</Stars>;
};
Rating.propTypes = {
  rating: PropTypes.number,
};

export default Rating;
